import { useSelector } from 'react-redux';

import { productFeatureDisabled } from 'dashboard/lib/productFeature';
import { Environment } from 'dashboard/models/environment';
import { Organization, ProductFeatureName } from 'dashboard/models/organization';
import { RootState } from 'dashboard/redux/store';

/**
 * @name `useProductFeature`
 *
 * A hook that returns if the provided product feature is
 * enabled for the current organization and environment type (sandbox v. production)
 *
 */
const useProductFeature = (productFeature: ProductFeatureName) => {
  const organization = useSelector<RootState, Organization>(
    (state: RootState) => state.organization?.organization,
  );
  const currentEnvironment = useSelector<RootState, Environment>(
    (state) => state.currentEnvironment?.currentEnvironment,
  );

  if (organization && currentEnvironment) {
    return !productFeatureDisabled(organization, productFeature, currentEnvironment.type);
  } else {
    return false;
  }
};

export default useProductFeature;
